import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import AssetsDepreciation from 'components/assets/depreciation';

class AssetsDisableDepreciations extends PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <Fragment>
      {(this.props.asset._financialDepreciationResult &&
        this.props.asset._financialDepreciationResult.yearly && (
          <AssetsDepreciation.Detail
            title="assets.depreciation_financial"
            depreciation={this.props.asset._financialDepreciationResult}
          />
        )) || <AssetsDepreciation.Fail title="assets.depreciation_financial" />}

      {(this.props.asset._fiscalDepreciationResult &&
        this.props.asset._fiscalDepreciationResult.yearly && (
          <AssetsDepreciation.Detail
            title="assets.depreciation_fiscal"
            depreciation={this.props.asset._fiscalDepreciationResult}
          />
        )) || <AssetsDepreciation.Fail title="assets.depreciation_fiscal" />}
    </Fragment>
  );
}

export default translate()(AssetsDisableDepreciations);



// WEBPACK FOOTER //
// src/components/assets/disable/AssetsDisableDepreciations.js